import React from 'react';
import InlineFilterPills from '../InlineFilterPills';

interface InlineLanguagePillsProps {
  value: string[];
  availableOptions: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
}

// Common language codes
const LANGUAGE_DISPLAY_MAP: Record<string, string> = {
  'en': 'EN',
  'ja': 'JP',
  'de': 'DE',
  'fr': 'FR',
  'it': 'IT',
  'es': 'ES',
  'pt': 'PT',
  'ru': 'RU',
  'ko': 'KO',
  'zh': 'CN',
  'zhs': 'CN',
  'zht': 'TW'
};

const InlineLanguagePills: React.FC<InlineLanguagePillsProps> = ({
  value,
  availableOptions,
  onChange,
  disabled = false,
}) => {
  // Create display map for available options
  const displayMap = availableOptions.reduce((acc, lang) => {
    const langLower = lang.toLowerCase();
    acc[lang] = LANGUAGE_DISPLAY_MAP[langLower] || lang.toUpperCase();
    return acc;
  }, {} as Record<string, string>);

  return (
    <InlineFilterPills
      value={value}
      availableOptions={availableOptions}
      onChange={onChange}
      displayMap={displayMap}
      disabled={disabled}
      minSelection={1}
      maxDisplay={4}
      placeholder="+ Lang"
      showAddButton={true}
    />
  );
};

export default InlineLanguagePills;